import { JsonObject, JsonProperty } from 'json2typescript';
import { UserTournamentMatch } from './user-tournament-match.model';

@JsonObject('UserTournament')
export class UserTournament {

  @JsonProperty('tournament_id', Number)
  tournamentId: number = 0;

  @JsonProperty('tournament_end_date_timestamp', Number)
  tournamentEndDateTimestamp: number = 0;

  @JsonProperty('best_points', Number)
  bestPoints: number = 0;

  @JsonProperty('best_match_count', Number)
  bestMatchCount: number = 0;

  @JsonProperty('current_points', Number)
  currentPoints: number = 0;

  @JsonProperty('current_match_count', Number)
  currentMatchCount: number = 0;

  @JsonProperty('is_active', Boolean)
  isActive: boolean = false;

  @JsonProperty('is_reward_granted', Boolean)
  isRewardGranted: boolean = false;

  @JsonProperty('rank', Number)
  rank: number = 0;

  @JsonProperty('matchs', [UserTournamentMatch])
  matchs: UserTournamentMatch[] = [];
}
